var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandirMas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.1 27.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1464;}.cls-2{fill:#fafafa;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3205-07-2019") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 27.1,
    height: 27.1,
    rx: 13.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.24 19.61 13.85 19.61 13.85 13.85 19.61 13.85 19.61 13.24 13.55 13.24 13.24 13.55 13.24 19.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.85 7.49 13.24 7.49 13.24 13.24 7.49 13.24 7.49 13.85 13.55 13.85 13.85 13.55 13.85 7.49"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandirMas);
export default __webpack_public_path__ + "static/media/expandir-mas.f7cd5c1f53478bda4335b07cce092a4e.svg";
export { ForwardRef as ReactComponent };